import { Head, Link } from "@inertiajs/react"
import { GraduationCap, Play, ChevronRight } from "lucide-react"
import { MemberLayout } from "../components/MemberLayout"
import { Card, CardContent } from "@/components/ui/card"

export default function TutorialVideosIndex({ currentUser, videos }) {
  return (
    <MemberLayout currentUser={currentUser}>
      <Head title="Tutorials - Kingdom Factor" />

      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-zinc-900">Tutorials</h1>
          <p className="text-zinc-600 mt-1">
            Learn how to use the member portal.
          </p>
        </div>

        {videos.length > 0 ? (
          <div className="space-y-2">
            {videos.map((video, index) => (
              <Link
                key={video.id}
                href={`/app/member/tutorial_videos/${video.slug}`}
                className="block"
              >
                <Card className="hover:bg-zinc-50 transition-colors cursor-pointer">
                  <CardContent className="flex items-center gap-4 py-4">
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-kf-red/10 text-kf-red flex items-center justify-center">
                      <Play className="h-4 w-4 ml-0.5" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="font-medium text-zinc-900">
                        {index + 1}. {video.title}
                      </p>
                      {video.description && (
                        <p className="text-sm text-zinc-500 mt-0.5 line-clamp-1">
                          {video.description.split("\n")[0]}
                        </p>
                      )}
                    </div>
                    <ChevronRight className="h-5 w-5 text-zinc-400 flex-shrink-0" />
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        ) : (
          // R7: friendly empty state until KF produces member tutorials —
          // never a blank list or an error.
          <div className="text-center py-12 text-zinc-500">
            <GraduationCap className="h-12 w-12 mx-auto mb-3 text-zinc-300" />
            <p className="font-medium">Tutorials are coming soon</p>
            <p className="text-sm mt-1">
              We're putting together short walkthroughs of the member portal.
              Check back soon.
            </p>
          </div>
        )}
      </div>
    </MemberLayout>
  )
}
